<template>
    <div class="recruit-page people">
        <!-- 公司简介头部 -->
        <div class="container">

            <!-- 2. 舒适办公环境 文字左飞入，图片右飞入 -->
            <section id="workAround" class="env-section">
                <h5 class="xLine animate-block animate-fade-up" data-animate="fade-up">{{ title[0] }}</h5>
                <div class="env-row flex-row">
                    <!-- 左侧文字：从左侧滑入 -->
                    <div class="env-left animate-block animate-fade-left" data-animate="fade-left" style="flex: 1.1;">
                        <h3>认识我们</h3>
                        <div class="intro-desc">
                            <p v-for="item in info.enParag" :key="item" class="wfparag">{{ item }}</p>
                        </div>
                    </div>
                    <!-- 右侧轮播图片：从右侧滑入 -->
                    <div class="env-right animate-block animate-fade-right" data-animate="fade-right"
                        style="flex: 0.9;">
                        <div class="custom-carousel" @wheel.prevent="handleOfficeWheel" @mouseenter="pauseOfficeTimer"
                            @mouseleave="startOfficeTimer">
                            <div class="carousel-img-box">
                                <img :src="officeImgList[currentOfficeIndex].url" loading="lazy" alt=""
                                    class="carousel-img" />
                                <div class="carousel-label">{{ officeImgList[currentOfficeIndex].label }}</div>
                                <div class="carousel-mask"></div>
                            </div>
                            <div class="carousel-btn left-btn" @click="prevOfficeImg">
                                <svg viewBox="0 0 24 24" width="20" height="20">
                                    <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" fill="none"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div class="carousel-btn right-btn" @click="nextOfficeImg">
                                <svg viewBox="0 0 24 24" width="20" height="20">
                                    <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" fill="none"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div class="carousel-dots">
                                <span v-for="(item, idx) in officeImgList" :key="idx" class="dot"
                                    :class="{ active: currentOfficeIndex === idx }"
                                    @click="currentOfficeIndex = idx"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- 3. 员工福利 图片右飞入，文字左飞入 -->
            <section id="goodJob" class="benefit-section">
                <h5 class="xLine animate-block animate-fade-up" data-animate="fade-up">{{ title[1] }}</h5>
                <p class="wfpg animate-block animate-fade-up" data-animate="fade-up">{{ info.welfare.pre }}</p>

                <div class="benefit-row flex-row">
                    <!-- 左侧轮播图片：从右侧滑入 -->
                    <div class="benefit-left animate-block animate-fade-right" data-animate="fade-right"
                        style="flex: 0.9;">
                        <div class="custom-carousel" @wheel.prevent="handleTeamWheel" @mouseenter="pauseTeamTimer"
                            @mouseleave="startTeamTimer">
                            <div class="carousel-img-box">
                                <img :src="teamImgList[currentTeamIndex].url" loading="lazy" alt=""
                                    class="carousel-img" />
                                <div class="carousel-label">{{ teamImgList[currentTeamIndex].label }}</div>
                                <div class="carousel-mask"></div>
                            </div>
                            <div class="carousel-btn left-btn" @click="prevTeamImg">
                                <svg viewBox="0 0 24 24" width="20" height="20">
                                    <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" fill="none"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div class="carousel-btn right-btn" @click="nextTeamImg">
                                <svg viewBox="0 0 24 24" width="20" height="20">
                                    <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" fill="none"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div class="carousel-dots">
                                <span v-for="(item, idx) in teamImgList" :key="idx" class="dot"
                                    :class="{ active: currentTeamIndex === idx }"
                                    @click="currentTeamIndex = idx"></span>
                            </div>
                        </div>
                    </div>

                    <!-- 右侧福利文字：从左侧滑入 -->
                    <div class="benefit-right animate-block animate-fade-left" data-animate="fade-left"
                        style="flex: 1.1;">
                        <div class="flex-evenly">
                            <div class="colorBox" v-for="item in info.welfare.ds" :key="item.bg"
                                :style="{ background: item.bg }">
                                <div class="crImg">
                                    <img style="height:100%" :src="item.icon" loading="lazy" alt="">
                                </div>
                                <p>{{ item.tips }}</p>
                            </div>
                        </div>
                        <div class="welfare-text">
                            <p v-for="item in info.welfare.parag" :key="item" class="wfparag">{{ item }}</p>
                        </div>
                    </div>
                </div>
            </section>

            <!-- 4. 招聘岗位区域 -->
            <section id="talentCome" class="job-section animate-block animate-fade-up" data-animate="fade-up">
                <h5 class="xLine">{{ title[2] }}</h5>
                <div class="address-wrap">
                    <p class="wfpg addr-txt">
                        <i class="addr-icon">📍</i>烟台工作地址：山东省烟台市莱山区莱盛路136号
                    </p>
                    <p class="pLine wfpg addr-txt">
                        <i class="addr-icon">📍</i>济南工作地址：山东省济南市槐荫区腊山河东路与威海路交叉口山东高速广场
                    </p>
                </div>

                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" v-for="job in jobList" :key="job.id">
                        <div class="job-card comeBox" @mouseenter="hoverId = job.id" @mouseleave="hoverId = null">
                            <div class="job-head dsInfo">
                                <div class="job-title-row">
                                    <h3 class="job-name">{{ job.name }}</h3>
                                    <span class="location-tag">{{ job.locationTag }}</span>
                                </div>
                                <p class="payNeed">
                                    <span class="salary-tag">薪资：{{ job.salary }}</span>
                                    <span class="num-tag">招聘人数：{{ job.need }}人</span>
                                </p>
                            </div>
                            <div class="job-detail comeText" v-show="hoverId === job.id">
                                <div class="detail-block">
                                    <h5 class="comeSkill">📋 岗位职责</h5>
                                    <div class="comeDs">
                                        <p v-for="(dutyItem, idx) in job.duty" :key="idx">{{ dutyItem }}</p>
                                    </div>
                                </div>
                                <div class="divide-line"></div>
                                <div class="detail-block">
                                    <h5 class="comeSkill">🎯 任职要求</h5>
                                    <div class="comeDs">
                                        <p v-for="(reqItem, idx) in job.require" :key="idx">{{ reqItem }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="sendinfo">
                                <div class="contact-item">
                                    <div class="icon-box">
                                        <img style="height:100%" :src="iconMail" loading="lazy" alt="">
                                    </div>
                                    <span>简历投递： info@loroi.com</span>
                                </div>
                                <div class="contact-item">
                                    <div class="icon-box">
                                        <img style="height:100%" :src="iconTel" loading="lazy" alt="">
                                    </div>
                                    <span>咨询电话： 0535-3931271</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecruitPeople',
    data() {
        return {
            hoverId: null,
            title: ['—— 工作环境 ——', '—— 员工福利 ——', '—— 人才招聘 ——'],
            currentOfficeIndex: 0,
            currentTeamIndex: 0,
            officeTimer: null,
            teamTimer: null,
            delayTime: 3000,
            // 静态图标抽离，解决模板@路径报错
            iconMail: require('@/assets/employ/tcicon1.png'),
            iconTel: require('@/assets/employ/tcicon2.png'),
            info: {
                basic: '山东医影智能科技有限公司（以下简称"医影智能"）是一家专注于"新一代信息技术+医学影像"技术研发的国家级高新技术企业、山东省专精特新中小企业。公司立足医学影像与人工智能、虚拟现实等前沿技术的交叉融合，致力于为医学影像人才培养提供全系列实验实训解决方案，持续助力我国医学影像事业的高质量发展。公司坐落于风景秀丽、宜居宜业的滨海城市——山东烟台，坐拥优美的海滨风光、舒适的办公环境与完善的城市配套。公司自创立以来，始终秉持以"仁爱为发展根基，技术创新为核心驱动力，人才建设为长远根本"的经营理念。团队氛围轻松纯粹、扁平化管理，重视每一位员工的成长与价值输出，为有志于深耕AI+医疗、医学教育领域的优秀人才，提供广阔的发展平台与清晰的晋升通道。现因公司业务拓展、产品迭代升级及市场布局扩大，面向社会广纳贤才，诚邀各界精英携手同行、共启新程！',
                environment: [
                    require('@/assets/employ/new-1.png'),
                    require('@/assets/employ/new-2.jpg'),
                    require('@/assets/employ/new-3.jpg'),
                    require('@/assets/employ/new-5.jpg'),
                    require('@/assets/employ/new-8.jpg'),
                    require('@/assets/employ/new-9.jpg'),
                    require('@/assets/employ/new-7.jpg'),
                ],
                enParag: [
                    '1.工作环境舒适优美；',
                    '2.工作氛围充满活力，我们团队汇聚才华出众的同事，互助学习的良好氛围；',
                    '3.扁平化企业管理，公司以人性化、个人价值最大化为管理核心，员工成长空间广阔，合理的晋升渠道；',
                    '4.年轻化团队成员，公司90后00后居多，人文环境包容大气，是年轻人才华施展的舞台。',
                    '加入我们，解锁更具挑战性的独立工作机会，助力快速成长！',
                ],
                welfare: {
                    pre: '员工是公司的宝贵财富，医影智能为员工提供完善多层次福利体系，全方位保障员工工作与生活：',
                    ds: [
                        { tips: '充分的基本保障', bg: '#1B9CA1', icon: require('@/assets/employ/wicon1.png') },
                        { tips: '员工关怀', bg: '#1795DF', icon: require('@/assets/employ/wicon2.png') },
                        { tips: '带薪假期', bg: '#E17F80', icon: require('@/assets/employ/wicon3.png') },
                        { tips: '各类补助', bg: '#D0A534', icon: require('@/assets/employ/wicon4.png') },
                        { tips: '健康关怀', bg: '#1EA9D2', icon: require('@/assets/employ/wicon5.png') },
                    ],
                    parag: [
                        '⭐ 五险一金、商业补充保险、法定节假日；',
                        '⭐ 项目绩效奖金、年度调薪、年终丰厚奖励；',
                        '⭐ 双通道晋升体系、定期内训学习、广阔成长空间；',
                        '⭐ 季度部门团建、节日礼品、生日福利、年度体检、日常餐补。',
                    ]
                },
                station: [
                    {
                        id: 1,
                        name: '医学影像营销工程师（全国）',
                        salary: '5K~10K',
                        need: 10,
                        locationTag: '全国可驻场',
                        work: [
                            '根据公司销售目标，跟踪国内医学院校及行业发展动态，挖掘公司产品相关专业客户需求，完成市场拓展与业务开发',
                            '独立开展院校客户拜访、商务洽谈、方案撰写、项目投标等工作，推动项目顺利签约',
                            '负责客户关系维护与长期运营，为院校提供专业、持续的售前与售后支持，提升客户满意度',
                            '跟进项目落地全流程，包括需求对接、方案制作、报价、产品演示、实施协调、验收推进等',
                            '按照合同约定跟进项目回款，管控应收账款，降低坏账风险',
                            '定期整理、汇总客户信息与项目进度，及时反馈市场情况及客户需求'
                        ],
                        limit: [
                            '医学影像技术、医学影像学、生物医学工程、智能医学工程、智能影像工程、制药工程等相关专业，3 年以上相关工作经验，优秀应届生可放宽',
                            '面向国内医学院校客户，能够独立完成院校开发、商机跟进、商务谈判、招投标及合同签订',
                            '熟练操作公司相关软硬件产品，可独立为院校教师进行产品演示、操作讲解与沟通',
                            '熟悉产品原理、技术参数、院校教学应用场景、合规资质及竞品优势',
                            '具备良好的商务表达、方案讲解与教学沟通能力，能快速理解院校需求并提供解决方案',
                            '职业素养良好，责任心强，积极进取，具备较强的学习能力、执行力与团队协作精神'
                        ]
                    },
                    {
                        id: 2,
                        name: '项目实施工程师（烟台）',
                        salary: '5K~8K',
                        need: 3,
                        locationTag: '烟台',
                        work: [
                            '负责项目全生命周期管理，涵盖客户对接、场地勘测、方案设计，中期设备安装、调试、质控，后期验收、培训与交付归档，确保项目按时、按质、按预算交付',
                            '严格执行质量控制标准，跟踪现场实施进度',
                            '组织跨部门（研发、生产、采购、质量、销售等）及客户、供应商的协调沟通，解决项目推进中的技术、资源、进度等问题，保障协作顺畅',
                            '开展项目风险识别与评估，制定风险应对预案，跟踪并管控项目风险，及时处理项目变更与异常情况',
                            '负责项目成本控制，跟踪项目费用支出，优化资源配置，确保项目经济效益达成',
                            '主导项目各阶段评审与验收，编制项目报告（进度、风险、质量、总结等），整理并归档项目文档'
                        ],
                        limit: [
                            '本科及以上学历',
                            '医学影像技术、医学影像学、智能医疗装备技术等相关专业优先；持有项目管理相关证书者优先',
                            '熟悉 DR、CT、MRI、直线加速器等医学影像设备拆解与组装流程，可独立完成设备现场调试',
                            '熟悉设备生产工艺、安装调试及质量控制规范',
                            '工作严谨细致、责任心强，具备优秀的风险预判与问题解决能力，能承受项目交付压力',
                            '具备良好的跨部门、客户沟通协调能力，可独立处理现场技术问题与项目冲突',
                            '抗压力强，适应出差'
                        ]
                    },
                    {
                        id: 3,
                        name: '医学影像AI算法工程师（教学实训方向）',
                        salary: '8K~15K',
                        need: 5,
                        locationTag: '烟台',
                        work: [
                            '负责医学影像 AI 算法模型的设计、开发与优化，包括影像分割、目标检测、影像分类、配准、影像组学等，并实现教学化与产品化落地',
                            '基于深度学习与大模型技术，构建医学影像 AI 教学案例、实训项目与实验平台，支撑医学影像相关教学与实训工作',
                            '结合临床影像场景，将 AI 技术与医学影像教学、规培、实训相结合，设计可演示、可实操、可教学的 AI 实训内容',
                            '参与医学影像 AI 教学产品或实训系统研发，提供算法、模型与技术方案支撑，提升系统性能与教学体验',
                            '跟踪医学影像 AI 与医疗大模型前沿技术动态，开展技术预研，推动前沿技术在教学与实训中的转化应用'
                        ],
                        limit: [
                            '生物医学工程、智能医学工程、智能影像工程、计算机、人工智能、数学等相关专业，硕士研究生及以上学历，3 年及以上相关工作经验',
                            '熟悉机器学习、深度学习基础理论，熟练使用 PyTorch/TensorFlow/MONAI 等主流深度学习框架，了解大模型在医学影像领域的应用',
                            '熟练掌握 Python 编程语言，具备良好代码功底，熟悉医学影像数据格式（DICOM、NIfTI 等）与处理流程',
                            '深入理解医学影像 AI 典型任务，如图像分割、目标检测、影像诊断等，有相关项目或落地经验者优先',
                            '具备医学影像教学、课程开发、实验实训、技术培训等相关经验，或愿意从事 AI+医学教育复合型工作者优先',
                            '具备较强的学习能力、问题分析与解决能力，沟通表达良好，责任心强，具备良好的团队协作精神'
                        ]
                    },
                    {
                        id: 4,
                        name: '前端开发工程师（烟台）',
                        salary: '5.5K~10K',
                        need: 2,
                        locationTag: '烟台',
                        work: [
                            '负责公司 Web 前端产品的需求分析、界面开发与功能实现，基于 Vue 技术栈完成前端页面的组件化、模块化开发',
                            '参与前端工程化建设，优化构建工具（Webpack/Vite）配置，提升项目打包效率与运行性能',
                            '负责页面响应式布局与移动端适配，解决不同浏览器兼容性问题，保障用户体验一致性',
                            '配合后端工程师完成前后端接口联调，参与接口设计与数据交互逻辑梳理',
                            '编写前端技术文档、测试用例，参与代码评审，保障代码质量与可维护性',
                            '关注前端技术发展趋势，引入新技术、新方案优化现有产品性能与架构'
                        ],
                        limit: [
                            '精通 HTML5、CSS3、JavaScript （ES6+），掌握响应式设计、移动端适配及浏览器兼容性处理技巧',
                            '熟练使用 Vue.js 框架及其生态（Vuex/Vue Router），理解组件化开发思想与响应式原理，有 Vue3+TypeScript 开发经验优先',
                            '了解 Webpack/Vite 等构建工具配置，熟悉 Git 版本控制流程，掌握前端单元测试 / 组件测试基础',
                            '1-3 年 Web 前端开发经验，具备独立完成项目的能力，参与过至少 2 个完整前端项目的全流程开发',
                            '具备良好的代码规范和文档编写习惯，学习能力与问题解决能力突出',
                            '具有较强的责任心，独立分析和解决问题的能力，具有较好的沟通能力和团队合作精神，具有良好的职业道德操守和创新精神'
                        ]
                    },
                    {
                        id: 5,
                        name: 'JAVA开发工程师（烟台）',
                        salary: '6K~12K',
                        need: 2,
                        locationTag: '烟台',
                        work: [
                            '负责后端服务及业务模块的设计与开发，编写高质量、高性能、易维护的 Java 代码',
                            '参与需求评审、系统架构设计、接口设计及开发计划制定',
                            '负责系统问题排查、性能优化与故障处理，快速定位并解决线上及开发过程中的问题',
                            '与产品、测试、前端等团队紧密协作，保障项目进度与产品质量'
                        ],
                        limit: [
                            '计算机相关专业本科及以上学历，1–3 年 Java 后端开发经验',
                            '精通 Java 开发语言，熟练使用 Spring、SpringBoot、SpringMVC、MyBatis 等主流开发框架',
                            '具备扎实的数据结构、算法与计算机基础，熟练掌握面向对象编程与常用设计模式',
                            '熟练使用 MySQL 等关系型数据库，熟悉 SQL 优化、索引设计及事务处理',
                            '熟悉 Tomcat、Nginx、Docker 等常用工具与中间件，掌握 Linux 基本操作与常用命令',
                            '了解敏捷开发流程，具备良好的编码规范、文档习惯与团队协作意识',
                            '责任心强，逻辑清晰，具备独立分析、定位并解决问题的能力，拥有良好的职业素养与创新意识'
                        ]
                    },
                    {
                        id: 6,
                        name: '数字媒体制作师（烟台）',
                        salary: '5K~8K',
                        need: 2,
                        locationTag: '烟台',
                        work: [
                            '负责在线开放课程及各类视频项目中二维动画内容的全流程创作，运用 Animate、After Effects、Flash 等专业二维动画软件，完成原画设计、中间帧绘制、动画合成等工作',
                            '负责课程视频、微课、宣传片的视觉包装、创意设计与整体美化；完成视频调色、画面修复、音频处理、剪辑包装等后期优化工作',
                            '参与课程及宣传类视频拍摄，协助完成场景布置、灯光调试、设备架设、道具准备等前期工作，配合团队保障拍摄流程顺畅、画面质量达标',
                            '主动学习并应用 AI 工具辅助动画制作、视频剪辑、图像生成、音频处理等工作；利用 AI 提升制作效率、优化视觉效果，探索创新表现形式'
                        ],
                        limit: [
                            '数字媒体艺术、影视动画、影视后期等相关专业，3 年以上相关工作经验',
                            '熟练使用 Animate、After Effects、Flash 等动画软件，能独立完成二维动画全流程制作',
                            '熟练使用 Adobe 系列软件（PS、AE、PR、AI 等），具备课程视频、宣传片、微课等制作经验',
                            '具备良好的视觉审美与创意能力，擅长视频包装、视觉设计与画面表达',
                            '熟悉相机、摄像机使用，掌握拍摄流程，可协助完成布光、场景布置等工作',
                            '具备 AI 工具学习与应用能力，能够使用 AI 进行图像生成、视频辅助制作、素材处理等，提升工作效率与作品质量',
                            '工作认真细致，执行力强，能承受项目压力，具备良好的团队协作与沟通能力，可按时高质量完成制作任务'
                        ]
                    },
                    {
                        id: 7,
                        name: '标书制作专员（烟台）',
                        salary: '4.5K~6K',
                        need: 2,
                        locationTag: '烟台',
                        work: [
                            '负责招标文件的搜集、研读与要点拆解，精准理解招标需求、评分标准及投标要求',
                            '负责标书整体规划、任务分解与进度统筹，确保项目有序推进',
                            '整合公司商务、技术、资质、业绩、服务方案等资料，独立完成标书撰写、排版、校对、装订、密封等全流程工作，确保内容完整、逻辑严谨、格式规范',
                            '熟悉招投标相关政策法规，严格按照政策与招标文件要求编制标书，有效规避废标风险',
                            '跟踪项目投标全流程，参与投标答疑、开标等工作，及时处理过程中的突发情况',
                            '负责投标文件整理、归档与复盘总结，持续优化投标材料与编制效率',
                            '主动学习并运用 AI 工具辅助文档处理、资料整理、内容提炼与排版优化，提升标书编制效率与质量'
                        ],
                        limit: [
                            '本科及以上学历，2 年以上标书制作、商务文案相关工作经验',
                            '精通 Office 办公软件，文字功底扎实，逻辑清晰，细节把控能力极强',
                            '熟悉招投标流程、标书编制规范，熟悉招投标相关政策法规，具备独立编制商务标、技术标的能力',
                            '具备极强的学习能力，能够快速掌握不同行业、不同类型项目的投标要点与编制要求',
                            '具备 AI 工具应用能力，能够使用 AI 辅助文案撰写、内容校对、资料整理、方案优化等工作',
                            '工作严谨细致、责任心强，具备良好的沟通协调、团队协作与抗压能力',
                            '能适应紧急项目赶工需求，可适应短期出差'
                        ]
                    }
                ]
            },
            officeImgList: [],
            teamImgList: [
                {
                    id: 1,
                    url: require('@/assets/employ/new-11.jpg'),
                    label: '公司菜园'
                },
                {
                    id: 2,
                    url: require('@/assets/employ/new-22.jpg'),
                    label: '节日福利'
                },
                {
                    id: 3,
                    url: require('@/assets/employ/new-33.jpg'),
                    label: '节日福利'
                },
                {
                    id: 4,
                    url: require('@/assets/employ/new-44.jpg'),
                    label: '节日福利'
                },
                {
                    id: 5,
                    url: require('@/assets/employ/new-55.jpg'),
                    label: '节日福利'
                },
                {
                    id: 6,
                    url: require('@/assets/employ/new-66.jpg'),
                    label: '节日福利'
                },
                {
                    id: 7,
                    url: require('@/assets/employ/new-77.jpg'),
                    label: '节日福利'
                },
            ],
            jobList: []
        }
    },
    created() {
        this.formatStationText()
        this.officeImgList = this.info.environment.map((url, index) => {
            const labelArr = ['公司', '荣誉展厅', '会议室', '实训走廊', '休闲水吧', '活动中心', '休闲区']
            return {
                id: index + 1,
                url,
                label: labelArr[index]
            }
        })
    },
    mounted() {
        this.startOfficeTimer()
        this.startTeamTimer()
        // 页面滚动进场动画监听
        this.initScrollAnimate()

    },
    beforeDestroy() {
        clearInterval(this.officeTimer)
        clearInterval(this.teamTimer)
        if (this.animateObserver) this.animateObserver.disconnect()
    },
    methods: {
        // 滚动进场动画初始化（兼容上下/左右三种动画）
        initScrollAnimate() {
            this.animateObserver = new IntersectionObserver((entries) => {
                entries.forEach(item => {
                    if (item.isIntersecting) {
                        item.target.classList.add('animate-active')
                        this.animateObserver.unobserve(item.target)
                    }
                })
            }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' })
            // 监听所有带animate-block的模块
            document.querySelectorAll('.animate-block').forEach(block => {
                this.animateObserver.observe(block)
            })
        },
        formatStationText() {
            const list = JSON.parse(JSON.stringify(this.info.station))
            for (let i = 0; i < list.length; i++) {
                const item = list[i]
                const workArr = item.work
                for (let j = 0; j < workArr.length; j++) {
                    workArr[j] = `${j + 1}.${workArr[j]}；`
                }
                workArr[workArr.length - 1] = workArr[workArr.length - 1].slice(0, -1) + '。'

                const limitArr = item.limit
                for (let j = 0; j < limitArr.length; j++) {
                    limitArr[j] = `${j + 1}.${limitArr[j]}；`
                }
                limitArr[limitArr.length - 1] = limitArr[limitArr.length - 1].slice(0, -1) + '。'

                item.duty = workArr
                item.require = limitArr
                this.jobList.push(item)
            }
        },
        startOfficeTimer() {
            clearInterval(this.officeTimer)
            this.officeTimer = setInterval(() => {
                this.nextOfficeImg()
            }, this.delayTime)
        },
        pauseOfficeTimer() {
            clearInterval(this.officeTimer)
        },
        nextOfficeImg() {
            const max = this.officeImgList.length - 1
            this.currentOfficeIndex = this.currentOfficeIndex >= max ? 0 : this.currentOfficeIndex + 1
        },
        prevOfficeImg() {
            const max = this.officeImgList.length - 1
            this.currentOfficeIndex = this.currentOfficeIndex <= 0 ? max : this.currentOfficeIndex - 1
        },
        handleOfficeWheel(e) {
            e.deltaY > 0 ? this.nextOfficeImg() : this.prevOfficeImg()
        },
        startTeamTimer() {
            clearInterval(this.teamTimer)
            this.teamTimer = setInterval(() => {
                this.nextTeamImg()
            }, this.delayTime)
        },
        pauseTeamTimer() {
            clearInterval(this.teamTimer)
        },
        nextTeamImg() {
            const max = this.teamImgList.length - 1
            this.currentTeamIndex = this.currentTeamIndex >= max ? 0 : this.currentTeamIndex + 1
        },
        prevTeamImg() {
            const max = this.teamImgList.length - 1
            this.currentTeamIndex = this.currentTeamIndex <= 0 ? max : this.currentTeamIndex - 1
        },
        handleTeamWheel(e) {
            e.deltaY > 0 ? this.nextTeamImg() : this.prevTeamImg()
        },
        scrollToJob() {
            const target = document.getElementById('talentCome')
            if (!target) return
            // 获取元素距离页面顶部高度
            const rectTop = target.getBoundingClientRect().top
            const pageScrollTop = window.pageYOffset
            // 减去120像素，数值越大，整体越往下；80/100/120自行微调
            const finalTop = rectTop + pageScrollTop - 130
            window.scrollTo({
                top: finalTop,
                behavior: 'smooth'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
$yyBlue: #2563eb;
$yyBlueLight: #4b7df5;
$yyBlueDark: #1a4fa8;
$font23: #1a1a2e;
$grayBF: #bfbfbf;
$black306: #303036;
$lightGray: #f5f7fa;
$lightBlueBg: #edf2ff;
$textGray: #4a4a5a;
$textLight: #6b6b7a;
$shadowSm: 0 2px 12px rgba(0, 0, 0, 0.06);
$shadowMd: 0 6px 24px rgba(37, 99, 235, 0.10);
$shadowLg: 0 12px 40px rgba(37, 99, 235, 0.16);
$radius-base: 10px;
$radius-lg: 12px;
$radius-xl: 16px;
$radius-xxl: 20px;
$transition: all 0.7s cubic-bezier(0.22, 1, 0.36, 1);

// ====================== 三套入场动画关键帧 ======================
// 从上往下淡入（头部、标题、招聘模块）
@keyframes fadeUp {
    from {
        opacity: 0;
        transform: translateY(40px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

// 从左侧滑入（文字区域）
@keyframes fadeLeft {
    from {
        opacity: 0;
        transform: translateX(-60px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

// 从右侧滑入（图片轮播区域）
@keyframes fadeRight {
    from {
        opacity: 0;
        transform: translateX(60px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

// 通用动画基础类
.animate-block {
    opacity: 0;
    transition: $transition;
}

// 向上入场
.animate-fade-up {
    transform: translateY(40px);

    &.animate-active {
        animation: fadeUp 0.7s ease forwards;
    }
}

// 左侧入场
.animate-fade-left {
    transform: translateX(-60px);

    &.animate-active {
        animation: fadeLeft 0.7s ease forwards;
    }
}

// 右侧入场
.animate-fade-right {
    transform: translateX(60px);

    &.animate-active {
        animation: fadeRight 0.7s ease forwards;
    }
}

.recruit-page {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    background: #ffffff;
}

.people {
    padding: 40px 0 60px;

    p,
    h4,
    h5,
    h3,
    h2 {
        margin: 0;
        font-weight: normal;
    }
}

.container {
    width: 70%;
    min-width: 900px;
    margin: 0 auto;
}

.flex-row {
    display: flex;
    gap: 48px;
    align-items: stretch;
    margin-top: 20px;
}

// ===== 公司介绍头部 =====
.section-title {
    font-size: 30px;
    color: #0a0a1a;
    margin: 0 0 28px;
    font-weight: 700;
    text-align: center;
    letter-spacing: 2px;
    position: relative;

    &::after {
        content: '';
        display: block;
        width: 60px;
        height: 4px;
        background: linear-gradient(90deg, $yyBlue, $yyBlueLight);
        border-radius: 2px;
        margin: 12px auto 0;
    }
}

.intro-top {
    margin-bottom: 64px;
    padding: 40px 40px 36px;
    background: linear-gradient(145deg, #f8faff 0%, #eef4ff 100%);
    border-radius: $radius-xxl;
    box-shadow: $shadowSm;
    border: 1px solid rgba(37, 99, 235, 0.06);
}

// ===== 章节标题 =====
.xLine {
    font-size: 18px;
    line-height: 2.4;
    color: $yyBlue;
    letter-spacing: 3px;
    font-weight: 700;
    position: relative;
    padding-left: 16px;

    &::before {
        content: '';
        width: 4px;
        height: 20px;
        background: linear-gradient(180deg, $yyBlue, $yyBlueLight);
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 2px;
    }
}

// ===== 认识我们 =====
.env-left h3 {
    font-size: 26px;
    margin-top: 0;
    margin-bottom: 20px;
    color: #0a0a1a;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 10px;

    &::before {
        content: '';
        width: 5px;
        height: 28px;
        background: linear-gradient(180deg, $yyBlue, $yyBlueLight);
        display: inline-block;
        border-radius: 3px;
    }
}

.intro-desc p {
    color: $textGray;
    line-height: 2;
    margin: 14px 0;
    font-size: 15px;
    text-align: left;
    position: relative;
    padding-left: 6px;
}

// ===== 自定义轮播 =====
.custom-carousel {
    width: 100%;
    height: 380px;
    position: relative;
    overflow: hidden;
    border-radius: $radius-xl;
    box-shadow: $shadowSm;
    transition: $transition;
    background: #f0f2f7;

    &:hover {
        box-shadow: $shadowLg;
    }

    .carousel-img-box {
        height: 100%;
        position: relative;
        overflow: hidden;

        .carousel-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            transition: transform 0.8s ease;
            background: #e9edf5;
        }

        &:hover .carousel-img {
            transform: scale(1.04);
        }
    }

    .carousel-mask {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 80px;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 100%);
    }

    .carousel-label {
        position: absolute;
        bottom: 24px;
        left: 0;
        width: 100%;
        color: #fff;
        text-align: center;
        font-size: 17px;
        z-index: 2;
        letter-spacing: 1px;
        font-weight: 500;
        text-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
    }

    // ===== 左右箭头 - 默认隐藏，hover显示 =====
    .carousel-btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 46px;
        height: 46px;
        background: rgba(255, 255, 255, 0.92);
        backdrop-filter: blur(8px);
        text-align: center;
        line-height: 46px;
        font-size: 22px;
        cursor: pointer;
        color: #333;
        border-radius: 50%;
        transition: $transition;
        z-index: 3;
        border: none;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
        display: flex;
        align-items: center;
        justify-content: center;
        // 默认隐藏
        opacity: 0;
        visibility: hidden;
        pointer-events: none;

        &:hover {
            background: #ffffff;
            transform: translateY(-50%) scale(1.12);
            color: $yyBlue;
            box-shadow: 0 4px 24px rgba(37, 99, 235, 0.3);
        }

        svg {
            display: block;
        }
    }

    // 鼠标悬停时显示按钮
    &:hover .carousel-btn {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
    }

    .left-btn {
        left: 16px;
    }

    .right-btn {
        right: 16px;
    }

    .carousel-dots {
        position: absolute;
        bottom: 14px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 10px;
        z-index: 3;

        .dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.35);
            cursor: pointer;
            transition: $transition;
            border: 1.5px solid rgba(255, 255, 255, 0.1);

            &.active {
                background: #fff;
                transform: scale(1.35);
                border-color: #fff;
                box-shadow: 0 0 12px rgba(255, 255, 255, 0.3);
            }

            &:hover:not(.active) {
                background: rgba(255, 255, 255, 0.7);
            }
        }
    }
}

// ===== 员工福利 =====
#goodJob {
    margin-top: 64px;

    .xLine {
        margin-bottom: 20px;
    }
}

.flex-evenly {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 14px 10px;
}

.colorBox {
    flex: 1;
    min-width: 100px;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 12px 16px;
    margin: 10px 0;
    border-radius: $radius-lg;
    transition: $transition;
    cursor: default;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

    &:hover {
        transform: translateY(-10px) scale(1.02);
        box-shadow: 0 16px 36px rgba(0, 0, 0, 0.18);
    }

    .crImg {
        height: 64px;
        filter: drop-shadow(0 2px 8px rgba(255, 255, 255, 0.2));

        img {
            background: rgba(255, 255, 255, 0.1);
            border-radius: 4px;
        }
    }

    p {
        margin: 0;
        padding-top: 14px;
        font-size: 14px;
        color: white;
        letter-spacing: 0.5px;
        font-weight: 600;
        text-align: center;
        text-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    }
}

.welfare-text {
    margin-top: 24px;

    .wfparag {
        color: $textGray;
        line-height: 2;
        margin: 8px 0;
        font-size: 15px;
    }
}

// ===== 招聘岗位 =====
#talentCome {
    margin-top: 64px;

    .xLine {
        margin-bottom: 26px;
    }
}

.address-wrap {
    margin-bottom: 36px;
    padding: 16px 24px;
    background: $lightGray;
    border-radius: $radius-lg;
    border-left: 4px solid $yyBlue;

    .addr-txt {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 4px 0;
        font-size: 14px;
        color: $textGray;
    }

    .addr-icon {
        color: $yyBlue;
        font-size: 18px;
    }
}

.addr-txt {
    margin: 8px 0;
}

.pLine {
    margin-bottom: 0 !important;
}

// ===== 招聘卡片 =====
.job-card {
    border: 1px solid #e8ecf5;
    border-radius: $radius-xl;
    transition: $transition;
    margin-bottom: 28px;
    overflow: hidden;
    background: #ffffff;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: transparent;
        transition: $transition;
        border-radius: 3px 0 0 3px;
    }

    &:hover {
        border-color: $yyBlue;
        box-shadow: $shadowLg;
        transform: translateY(-6px);

        &::before {
            background: linear-gradient(180deg, $yyBlue, $yyBlueLight);
        }
    }
}

.job-head {
    padding: 26px 26px 14px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.job-title-row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px;
}

.job-name {
    font-size: 20px;
    margin: 0;
    color: #0a0a1a;
    font-weight: 700;
    line-height: 1.3;
}

.location-tag {
    font-size: 13px;
    padding: 4px 14px;
    background: $lightBlueBg;
    color: $yyBlue;
    border-radius: 20px;
    white-space: nowrap;
    font-weight: 600;
    letter-spacing: 0.3px;
}

.payNeed {
    margin: 14px 0 4px;
    display: flex;
    gap: 20px;
    font-size: 14px;

    .salary-tag {
        font-weight: 600;
        font-size: 15px;
        margin-top: 5px;
    }

    .num-tag {
        color: $textGray;
        margin-top: 5px;
    }
}

.job-detail {
    border-top: 1px solid #eef2f9;
    margin: 0 26px;
    padding: 18px 0 16px;
    max-height: 260px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, $yyBlue, $yyBlueLight);
        border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
        background: #f0f4fe;
        border-radius: 3px;
    }
}

.divide-line {
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, transparent, #dde1ec, transparent);
    margin: 14px 0;
}

.detail-block {
    h5 {
        font-size: 16px;
        color: #0a0a1a;
        margin: 0 0 8px;
        font-weight: 700;
        letter-spacing: 0.3px;
    }

    p {
        font-size: 14px;
        color: $textGray;
        line-height: 1.9;
        margin: 5px 0;
    }
}

.comeDs p {
    max-width: 100%;
    text-align: left;
}

// ===== 底部联系栏 =====
.sendinfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 26px;
    color: white;
    background: #2563AF;
    margin-top: 16px;
    flex-wrap: wrap;
    gap: 10px;

    .contact-item {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.3px;

        .icon-box {
            height: 22px;
            filter: brightness(0) invert(1);
            opacity: 0.9;

            img {
                background: rgba(255, 255, 255, 0.08);
                border-radius: 3px;
            }
        }
    }
}

// ===== 通用文字样式 =====
.infopg,
.wfpg,
.wfparag {
    font-size: 15px;
    color: $font23;
    line-height: 2;
    letter-spacing: 0.3px;
}

.infopg,
.wfparag {
    text-align: left;
}

#workAround .wfparag:last-of-type {
    font-weight: 700;
    color: $yyBlue;
    font-size: 16px;
    background: $lightBlueBg;
    padding: 8px 16px;
    border-radius: 8px;
    display: inline-block;
}

// ===== 响应式 =====
@media only screen and (max-width: 1200px) {
    .container {
        width: 84%;
        min-width: unset;
    }

    .flex-row {
        gap: 32px;
    }
}

@media only screen and (max-width: 992px) {
    .container {
        width: 90%;
    }

    .custom-carousel {
        height: 320px;
    }

    .intro-top {
        padding: 28px 24px;
    }
}

@media only screen and (max-width: 767px) {
    .people {
        padding: 20px 0 40px;
    }

    .container {
        width: 96%;
        min-width: unset;
    }

    .flex-row {
        flex-direction: column;
        gap: 28px;
    }

    .custom-carousel {
        height: 240px;
    }

    .intro-top {
        padding: 20px 16px;
        margin-bottom: 40px;
    }

    .section-title {
        font-size: 22px;
    }

    .job-title-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .sendinfo {
        flex-direction: column;
        align-items: flex-start;
        padding: 14px 18px;
    }

    .job-detail {
        max-height: 200px;
        margin: 0 16px;
    }

    .job-head {
        padding: 18px 18px 12px;
    }

    .colorBox {
        min-width: 70px;
        padding: 14px 8px 12px;

        .crImg {
            height: 48px;
        }

        p {
            font-size: 12px;
            padding-top: 10px;
        }
    }

    .flex-evenly {
        gap: 8px;
    }

    .address-wrap {
        padding: 12px 16px;
    }

    .job-card {
        margin-bottom: 20px;
    }

    .payNeed {
        flex-wrap: wrap;
        gap: 10px;
    }

    // 移动端轮播按钮保持可见（触摸设备友好）
    .custom-carousel {
        .carousel-btn {
            opacity: 0.7;
            visibility: visible;
            pointer-events: auto;
            width: 36px;
            height: 36px;

            svg {
                width: 16px;
                height: 16px;
            }
        }
    }
}

@media only screen and (max-width: 480px) {
    .custom-carousel {
        height: 200px;
    }

    .env-left h3 {
        font-size: 20px;
    }

    .job-name {
        font-size: 17px;
    }

    .carousel-btn {
        width: 32px !important;
        height: 32px !important;

        svg {
            width: 14px !important;
            height: 14px !important;
        }
    }

    .carousel-dots .dot {
        width: 8px !important;
        height: 8px !important;
    }
}
</style>